import * as Yup from "yup";
import { StringValidation } from "./PlanSchema";

export const UserSchema = Yup.object().shape({
  first_name: StringValidation.label("First name"),
  last_name: StringValidation.label("Last name"),
  email: StringValidation.label("Email"),
});
